import am1 from "../assets/works/am/am1.png";
import am2 from "../assets/works/am/am2.png";
import am3 from "../assets/works/am/am3.png";
import am4 from "../assets/works/am/am4.png";
import am5 from "../assets/works/am/am5.png";
import am6 from "../assets/works/am/am6.png";

import ka1 from "../assets/works/ka/ka1.png";
import ka2 from "../assets/works/ka/ka2.png";
import ka3 from "../assets/works/ka/ka3.png";
import ka4 from "../assets/works/ka/ka4.png";
import ka5 from "../assets/works/ka/ka5.png";

import ma1 from "../assets/works/ma/ma1.png";
import ma2 from "../assets/works/ma/ma2.png";
import ma3 from "../assets/works/ma/ma3.png";
import ma4 from "../assets/works/ma/ma4.png";
import ma5 from "../assets/works/ma/ma5.png";
import ma6 from "../assets/works/ma/ma6.png";

import for1 from "../assets/works/for/for1.png";
import for2 from "../assets/works/for/for2.png";
import for3 from "../assets/works/for/for3.png";
import for4 from "../assets/works/for/for4.png";
import for5 from "../assets/works/for/for5.png";
import for6 from "../assets/works/for/for6.png";

import di1 from "../assets/works/di/di1.png";
import di2 from "../assets/works/di/di2.png";
import di3 from "../assets/works/di/di3.png";
import di4 from "../assets/works/di/di4.png";
import di5 from "../assets/works/di/di5.png";
import di6 from "../assets/works/di/di6.png";

import lam1 from "../assets/works/lam/lam1.png";
import lam2 from "../assets/works/lam/lam2.png";
import lam3 from "../assets/works/lam/lam3.png";
import lam4 from "../assets/works/lam/lam4.png";
import lam5 from "../assets/works/lam/lam5.png";
import lam6 from "../assets/works/lam/lam6.png";

import xc1 from "../assets/works/xc/xc1.png";
import xc2 from "../assets/works/xc/xc2.png";
import xc3 from "../assets/works/xc/xc3.png";
import xc4 from "../assets/works/xc/xc4.png";
import xc5 from "../assets/works/xc/xc5.png";
import xc6 from "../assets/works/xc/xc6.png";

import ne1 from "../assets/works/ne/ne1.png";
import ne2 from "../assets/works/ne/ne2.png";
import ne3 from "../assets/works/ne/ne3.png";
import ne4 from "../assets/works/ne/ne4.png";
import ne5 from "../assets/works/ne/ne5.png";
import ne6 from "../assets/works/ne/ne6.png";

import pi1 from "../assets/works/pi/pi1.png";
import pi2 from "../assets/works/pi/pi2.png";
import pi3 from "../assets/works/pi/pi3.png";

import te1 from "../assets/works/te/te1.png";
import te2 from "../assets/works/te/te2.png";
import te3 from "../assets/works/te/te3.png";
import te4 from "../assets/works/te/te4.png";
import te5 from "../assets/works/te/te5.png";
import te6 from "../assets/works/te/te6.png";

import ems1 from "../assets/works/ems/ems1.png";
import ems2 from "../assets/works/ems/ems2.png";
import ems3 from "../assets/works/ems/ems3.png";
import ems4 from "../assets/works/ems/ems4.png";
import ems5 from "../assets/works/ems/ems5.png";
import ems6 from "../assets/works/ems/ems6.png";

import ca1 from "../assets/works/ca/ca1.png";
import ca2 from "../assets/works/ca/ca2.png";
import ca3 from "../assets/works/ca/ca3.png";
import ca4 from "../assets/works/ca/ca4.png";
import ca5 from "../assets/works/ca/ca5.png";
import ca6 from "../assets/works/ca/ca6.png";

//mobiles
import fo1 from "../assets/app/food/fo1.jpg";
import fo2 from "../assets/app/food/fo2.jpg";
import fo3 from "../assets/app/food/fo3.jpg";
import fo4 from "../assets/app/food/fo4.jpg";
import fo5 from "../assets/app/food/fo5.jpg";
import fo6 from "../assets/app/food/fo6.jpg";
import fo7 from "../assets/app/food/fo7.jpg";
import fo8 from "../assets/app/food/fo8.jpg";

import to1 from "../assets/app/todo/to1.jpg";
import to2 from "../assets/app/todo/to2.jpg";
import to3 from "../assets/app/todo/to3.jpg";
import to4 from "../assets/app/todo/to4.jpg";
import to5 from "../assets/app/todo/to5.jpg";
import to6 from "../assets/app/todo/to6.jpg";
import to7 from "../assets/app/todo/to1.jpg";
import to8 from "../assets/app/todo/to2.jpg";

import cry1 from "../assets/app/cryptopro/cry1.png";
import cry2 from "../assets/app/cryptopro/cry2.png";
import cry3 from "../assets/app/cryptopro/cry3.png";
import cry4 from "../assets/app/cryptopro/cry4.png";
import cry5 from "../assets/app/cryptopro/cry5.png";
import cry6 from "../assets/app/cryptopro/cry1.png";
import cry7 from "../assets/app/cryptopro/cry2.png";
import cry8 from "../assets/app/cryptopro/cry3.png";

import bm1 from "../assets/works/bm/bm1.png";
import bm2 from "../assets/works/bm/bm2.png";
import bm3 from "../assets/works/bm/bm3.png";
import bm4 from "../assets/works/bm/bm4.png";
import bm5 from "../assets/works/bm/bm5.png";

import ch1 from "../assets/works/ch/ch1.png";
import ch2 from "../assets/works/ch/ch2.png";
import ch3 from "../assets/works/ch/ch3.png";

import gi1 from "../assets/works/gi/gi1.png";
import gi2 from "../assets/works/gi/gi2.png";
import gi3 from "../assets/works/gi/gi3.png";
import gi4 from "../assets/works/gi/gi4.png";
import gi5 from "../assets/works/gi/gi5.png";

import sc1 from "../assets/works/sc/sc1.png";
import sc2 from "../assets/works/sc/sc2.png";
import sc3 from "../assets/works/sc/sc3.png";
import sc4 from "../assets/works/sc/sc4.png";
import sc5 from "../assets/works/sc/sc5.png";

import map1 from "../assets/works/map/map1.png";
import map2 from "../assets/works/map/map2.png";
import map3 from "../assets/works/map/map3.png";
import map4 from "../assets/works/map/map4.png";
import map5 from "../assets/works/map/map5.png";
import map6 from "../assets/works/map/map6.png";

import ad1 from "../assets/works/ad/ad1.png";
import ad2 from "../assets/works/ad/ad2.png";
import ad3 from "../assets/works/ad/ad3.png";
import ad4 from "../assets/works/ad/ad4.png";
import ad5 from "../assets/works/ad/ad5.png";
import ad6 from "../assets/works/ad/ad6.png";

import sh1 from "../assets/works/sh/sh1.png";
import sh2 from "../assets/works/sh/sh2.png";
import sh3 from "../assets/works/sh/sh3.png";
import sh4 from "../assets/works/sh/sh4.png";
import sh5 from "../assets/works/sh/sh5.png";

import no1 from "../assets/works/no/no1.png";
import no2 from "../assets/works/no/no2.png";
import no3 from "../assets/works/no/no3.png";
import no4 from "../assets/works/no/no4.png";
import no5 from "../assets/works/no/no5.png";
import no6 from "../assets/works/no/no6.png";

const projects = [
  {
    id: 0,
    link: "ambamotors",
    img1: am1,
    img2: am2,
    img3: am3,
    img4: am4,
    img5: am5,
    img6: am6,
    stack: "#React.js,#Node.js,#Express.js,#MongoDB,#Redux,etc",
    title: "Amba Motors (Garage)",
    desc: "Amab Motors is the Garage or say workshop of cars and the owner of the workshop is my Father. So this webapp is all about how the user can register/login them account and access the things which is present on the webapps.Their is the bunch of functionlity and services are provided to the user for their valueable and lovely cars. ",
    website: "https://ambamotors.vercel.app/",
    code: "https://github.com/Abhishekkuntare/ambamotors",

    prev: "/",
  },
  {
    id: 1,
    link: "kaff",
    img1: ka1,
    img2: ka2,
    img3: ka3,
    img4: ka4,
    img5: ka5,
    stack: "#React.js,#Node.js,#Express.js,#MongoDB",
    title: "KAFF (Foodie",
    desc: "In my portfolio, I proudly present KAFF, an engaging online foodie web app. Crafted using the MERN stack and fortified with Razorpay's secure payment processing, Kaff is your go-to destination for mouthwatering burgers. This project showcases my expertise in web development and e-commerce integration while offering burger enthusiasts a seamless digital dining experience. ",
    website: "https://foodie-frontend-nine.vercel.app/",
    code: "https://github.com/Abhishekkuntare/foodie_frontend",
    prev: "/",
  },
  {
    id: 2,
    link: "madebyme",
    img1: ma1,
    img2: ma2,
    img3: ma3,
    img4: ma4,
    img5: ma5,
    img6: ma6,
    stack: "#React.js,#Node.js,#Express.js,#MongoDB,#Redux,etc",
    title: "Made By Me",
    desc: "Made By Me is the Online Course web app which  contains the distant study courses and full HD videos/lectures on each type of domain so that the user is able to gain and aquired the best konwlege.I also include the subscription intrigity in it.The user can access course by  subscription as a month,as a year This is made by the MERN technology and differnt libray's",
    website: "https://madebyme.vercel.app/",
    code: "https://github.com/Abhishekkuntare/madebyme_frontend",
    prev: "/",
  },
  {
    link: "fornite",
    id: 3,
    img1: for1,
    img2: for2,
    img3: for3,
    img4: for4,
    img5: for5,
    img6: for6,
    stack: "#React.js,#CSS,#Firebase,#Animations",
    title: "Fornite (Create/Build/Play)",
    desc: "Fornite is the game and this website basically based on the UI/Ux and you can see the daily posts ,news ,updates here.Fornite is one the most popular game. I used the various technolgoy to build this webapp such as react,css,js,firebase,etc. ",
    website: "https://fortnite-6eceb.web.app/",
    code: "https://github.com/Abhishekkuntare",
    prev: "/",
  },

  {
    link: "disneyplus",
    id: 4,
    img1: di1,
    img2: di2,
    img3: di3,
    img4: di4,
    img5: di5,
    img6: di6,
    stack: "#React.js,#CSS,#Firebase,#Styled Components",
    title: "Disney+ (clone)",
    desc: "Disney+, also known as Disney Plus, is a popular subscription-based streaming service owned and operated by The Walt Disney Company. Launched in November 2019, Disney+ offers a vast library of movies and TV shows from various Disney-owned franchises, including Disney, Pixar, Marvel, Star Wars, and National Geographic. ",
    website: "https://disney-plus-3dc00.web.app",
    code: "https://github.com/Abhishekkuntare",
    prev: "/",
  },
  {
    link: "lamborghini",
    id: 5,
    img1: lam1,
    img2: lam2,
    img3: lam3,
    img4: lam4,
    img5: lam5,
    img6: lam6,
    stack: "#React.js,#CSS,#Firebase,#Styled Components",
    title: "Lamborghini (Cars)",
    desc: "Lamborghini is an Italian luxury sports car manufacturer known for producing some of the most iconic and high-performance vehicles in the world. The company was founded in 1963 by Ferruccio Lamborghini and has since become synonymous with speed, power, and extravagance. ",
    website: "https://lamborghini-f74a3.web.app/",
    code: "https://github.com/Abhishekkuntare/Lamborgihini",
    prev: "/",
  },
  {
    link: "xcrypto",
    id: 6,
    img1: xc1,
    img2: xc2,
    img3: xc3,
    img4: xc4,
    img5: xc5,
    img6: xc6,
    stack: "#React.js,#CSS,#APIs,#Redux",
    title: "X-crypto ",
    desc: "X-crypto is the basic webapp which uses the apis and shows the various types of crypto's value,up and down,market grown,and graphs that is very helpful for the user whoever visit this webapp that's why i build this webapp",
    website: "https://x-crypto-two.vercel.app/",
    code: "https://github.com/Abhishekkuntare/x-crypto",
    prev: "/",
  },
  {
    link: "netflix",
    id: 7,
    img1: ne1,
    img2: ne2,
    img3: ne3,
    img4: ne4,
    img5: ne5,
    img6: ne6,
    stack: "#React.js,#CSS,#Styled Componets,#Firebase",
    title: "Netflix ",
    desc: "Netflix is a popular streaming service that offers a wide variety of movies, TV shows, documentaries, and original content. It was founded in 1997 by Reed Hastings and Marc Randolph in Los Gatos, California. Initially, Netflix started as a DVD rental-by-mail service, allowing subscribers to rent movies and TV shows by mail and return them at their convenience.",
    website: "https://netflix-153d3.web.app/",
    code: "https://github.com/Abhishekkuntare/Netflix",
    prev: "/",
  },
  {
    link: "pokemon",
    id: 8,
    img1: pi1,
    img2: pi2,
    img3: pi3,
    img4: pi1,
    img5: pi2,
    img6: pi3,
    stack: "#HTML,#CSS,#JavaScript,#Vercel",
    title: "Pokemon ",
    desc: "Pokemon is the basic web app which is uses the APIs and fetch data according to that and i also implement the search fucntionlty init so that it's feel terrific..",
    website: "https://pokemon-liard-eta.vercel.app/",
    code: "https://github.com/Abhishekkuntare/pokemon",
    prev: "/",
  },
  {
    link: "tesla",
    id: 9,
    img1: te1,
    img2: te2,
    img3: te3,
    img4: te4,
    img5: te5,
    img6: te6,
    stack: "#React.js,#CSS,#Styled Componets,#Firebase",
    title: "Tesla ",
    desc: "Tesla cars are electric vehicles manufactured by the American company Tesla, Inc. Founded in 2003 by Elon Musk, Tesla has gained widespread recognition for its innovative approach to electric vehicle design and technology. Here are some key features and characteristics of Tesla cars:",
    website: "https://tesla-cbfc3.web.app/",
    code: "https://github.com/Abhishekkuntare/tesla-Clone",
    prev: "/",
  },
  {
    link: "persistence",
    id: 10,
    img1: ems1,
    img2: ems2,
    img3: ems3,
    img4: ems4,
    img5: ems5,
    img6: ems6,
    stack: "#React.js,#MYSQL,#Charka-Ui,#Netlify",
    title: "Persistence (EMS)",
    desc: "Persistence is the Employee Management System and it is also my 3rd year MiniProject. So as a project leader i was created all the components of these project and provide some extra resourses to build these application apart from that my team members had given their best..",
    website: "https://persistenceemployee.netlify.app/",
    code: "https://github.com/Abhishekkuntare/persistence",
    prev: "/",
  },
  {
    link: "carnival",
    id: 11,
    img1: ca1,
    img2: ca2,
    img3: ca3,
    img4: ca4,
    img5: ca5,
    img6: ca6,
    stack: "#MERN,#APIs,#Redux,#Postman,#Netlify",
    title: "Carnival (Social Media)",
    desc: "Carnival is the social media app which is used to create the account and add posts,comments,likes on that posts by the user.This is similar to another social media apps.Yeah the UI/UX is very basic i know because i deeply work on the backend part thats why. Make sure you like it..",
    website: "https://carnivall.netlify.app/",
    code: "https://github.com/Abhishekkuntare",
    prev: "/",
  },
  {
    link: "chatapp",
    id: 13,
    img1: ch1,
    img2: ch2,
    img3: ch3,
    img4: ch1,
    img5: ch2,
    img6: ch2,
    stack: "#MERN,#APIs,#Socket.io,#Postman,#Render",
    title: "Chat App ",
    desc: "Real-time chat app powered by MERN stack and Socket.IO for seamless communication. Experience instant messaging with lightning-fast updates and a dynamic interface!",
    website: "https://chatapp-0h5v.onrender.com/login",
    code: "https://github.com/Abhishekkuntare/chatapp",
    prev: "/",
  },
  {
    link: "github",
    id: 15,
    img1: gi1,
    img2: gi2,
    img3: gi3,
    img4: gi4,
    img5: gi5,
    img6: gi1,
    stack: "#MERN,#APIs,#Passport.js,#Postman,#Render",
    title: "Gihub-Clone ",
    desc: "I proudly showcase my project, a GitHub clone built with the MERN stack (MongoDB, Express.js, React.js, Node.js) and integrated authentication using Passport.js. This project demonstrates my proficiency in full-stack development, including database management, server-side scripting, and front-end design. With a focus on replicating key functionalities of the original GitHub platform, such as user authentication and repository management, this project highlights my ability to create robust and scalable web applications using modern technologies.",
    website: "https://github-clone-6ft5.onrender.com/",
    code: "https://github.com/Abhishekkuntare/github-clone",
    prev: "/",
  },
  {
    link: "maps",
    id: 16,
    img1: map1,
    img2: map2,
    img3: map3,
    img4: map4,
    img5: map5,
    img6: map6,
    stack: "#React.js,#Next.js,#Leaflet.js,#Algolia,#Vercel",
    title: "Maps",
    desc: "Welcome to the dynamic map interface of Maps, designed for easy location exploration. The main screen features a map with a top-left, Algolia-powered search bar for real-time suggestions. Selecting a suggestion recenters the map to the chosen location, displaying detailed markers. • Maps’ frontend, powered by Next.js and Algolia, utilizes Leaflet for maps and MarkerClusterGroup for efficient clustering, ensuring a seamless user experience",
    website: "https://frontend-task-maps.vercel.app/",
    code: "https://github.com/Abhishekkuntare/FrontendTask-Maps",
    prev: "/",
  },
  {
    link: "smartcontract",
    id: 17,
    img1: sc1,
    img2: sc2,
    img3: sc3,
    img4: sc4,
    img5: sc5,
    stack: "#React.js,#Netlify,#API",
    title: "Maps",
    desc: "I have developed a smart contract project using React.js, leveraging its capabilities to create a user-friendly interface for interacting with blockchain smart contracts. The project integrates React components with Ethereum smart contracts, allowing seamless execution of transactions and interaction with decentralized applications (dApps) on the Ethereum blockchain. The interface facilitates both reading from and writing to smart contracts, enhancing user experience and accessibility to blockchain technology.",
    website: "https://smart-contract-bouding-curve.netlify.app/",
    code: "https://github.com/Abhishekkuntare",
    prev: "/",
  },
  {
    link: "adminpannel",
    id: 18,
    img1: ad1,
    img2: ad2,
    img3: ad3,
    img4: ad4,
    img5: ad5,
    img6: ad6,
    stack: "#React.js,#Node.js,#Express.js#Chart.js",
    title: "Admin Pannel",
    desc: "I developed an admin panel using the MERN stack (MongoDB, Express.js, React.js, Node.js), featuring Chart.js for dynamic data visualization. This project facilitates data management and analysis with MongoDB for storage, Express.js for API development, React.js for the frontend interface, and Node.js for server-side operations. Chart.js enhances the admin panel by providing interactive charts that empower data-driven decision-making and insights.",
    website: "https://adminn-pannell.netlify.app/",
    code: "https://github.com/Abhishekkuntare/Dashboard_frontend",
    prev: "/",
  },
  {
    link: "shopify",
    id: 19,
    img1: sh1,
    img2: sh2,
    img3: sh3,
    img4: sh4,
    img5: sh5,
    stack: "#React.js,#Node.js,#Shopify#Mongodb",
    title: "Shopify",
    desc: "I developed a Shopify website utilizing the MERN (MongoDB, Express.js, React, Node.js) stack, integrating the Shopify API to efficiently fetch and display products and orders. The backend is powered by Node.js and Express.js, managing server-side operations and API requests to Shopify. MongoDB serves as the database for storing user data and custom application information. The frontend is built with React, providing a responsive and dynamic user interface that showcases product listings and order details fetched from the Shopify API.",
    website: "https://shopfiy.netlify.app/",
    code: "https://github.com/Abhishekkuntare/shopify_frontend",
    prev: "/",
  },
  {
    link: "invoice",
    id: 20,
    img1: sh1,
    img2: sh2,
    img3: sh3,
    img4: sh4,
    img5: sh5,
    stack: "#React.js,#Redux,#Netlify",
    title: "Ecommerce Invoice",
    desc: "I developed an e-commerce invoice website using the MERN (MongoDB, Express.js, React, Node.js) stack, designed to manage and generate invoices for online transactions. The React-based frontend delivers a responsive and user-friendly interface, allowing users to view, create, and manage invoices efficiently. This setup leverages the MERN stack's scalability and flexibility, ensuring secure data handling and a seamless user experience for managing e-commerce invoices..",
    website: "https://ecommerce-invoice.netlify.app/",
    code: "https://github.com/Abhishekkuntare/ecommerce_invoice",
    prev: "/",
  },
  {
    link: "nodes",
    id: 21,
    img1: no1,
    img2: no2,
    img3: no3,
    img4: no4,
    img5: no5,
    img6: no6,
    stack: "#React.js,#React Flow,#Vercel,#Tailwindcss",
    title: "Nodes",
    desc: "I created a messaging application using React, Tailwind CSS, and React Flow to visualize message nodes effectively. React serves as the core framework, providing a dynamic and responsive user interface. Tailwind CSS is employed for styling, ensuring a sleek and modern design with minimal effort through its utility-first CSS approach. React Flow is utilized to create and manage the nodes of the messages, offering an intuitive and interactive visual representation of the message flow. This combination results in a highly functional and visually appealing messaging application, with seamless user interaction and efficient message management.",
    website: "https://nodes-sand.vercel.app/",
    code: "https://github.com/Abhishekkuntare/Nodes",
    prev: "/",
  },
  {
    link: "blogme",
    id: 14,
    img1: bm1,
    img2: bm2,
    img3: bm3,
    img4: bm4,
    img5: bm5,
    stack: "#MERN,#APIs,#Redux,#Postman,#Netlify",
    title: "Blog me ",
    desc: "Blog me a blog web app where only admin can create blogs and other users can read blogs.Explore Boundless Horizons: Where Words Unite and Ideas Ignite. Welcome to a World of Insight and Inspiration!",
    website: "https://blogme-frontend.vercel.app/",
    code: "https://github.com/Abhishekkuntare/Blogme",
    prev: "/",
  },

  //mobiles ssss
  {
    link: "cryptopronef",
    id: 0,
    img1: cry1,
    img2: cry2,
    img3: cry3,
    img4: cry4,
    img5: cry5,
    img6: cry6,
    img7: cry7,
    img8: cry8,
    stack: "#React Native,#Expo,#Animations,#Github",
    title: "Crypto-Pronef",
    desc: "Introducing CryptoPronef, the ultimate app for cryptocurrency enthusiasts and investors. Whether you're a seasoned trader or a curious beginner, CryptoPronef provides a comprehensive suite of features and tools to help you navigate the dynamic world of cryptocurrencies. Stay up-to-date with market trends, track your portfolio, and make informed investment decisions with confidence.",
    website: "https://github.com/Abhishekkuntare/ReactNativeNFTApp",
    prev: "/",
  },
  {
    link: "todo",
    id: 1,
    img1: to1,
    img2: to2,
    img3: to3,
    img4: to4,
    img5: to5,
    img6: to6,
    img7: to7,
    img8: to8,
    stack: "#React Native,#Animations,#Expo,#Github",
    title: "To-Do App ",
    desc: "Introducing our powerful and intuitive React Native Todo app, designed to help you stay organized, increase productivity, and achieve your goals. With our app, you can effectively manage tasks, prioritize your activities, and never let important deadlines slip through the cracks. Say goodbye to scattered sticky notes and overwhelming to-do lists  our app has got you covered. Here are the key features of our Todo app:..",
    website: "https://github.com/Abhishekkuntare/Reactnative_app_todo",
    prev: "/",
  },
  {
    link: "foodie",
    id: 2,
    img1: fo1,
    img2: fo2,
    img3: fo3,
    img4: fo4,
    img5: fo5,
    img6: fo6,
    img7: fo7,
    img8: fo8,
    stack: "#React Native,#APIs,#Redux,#Expo",
    title: "Foodie (App)",
    desc: "Introducing our innovative foodie app, the ultimate solution for all your culinary needs. With our app, you'll embark on a delightful journey through the world of gastronomy, conveniently accessible from the palm of your hand. Whether you're a seasoned chef, a novice cook, or someone who simply appreciates good food, our app has something to offer everyone. Discover a wide range of features designed to enhance your culinary experience. From recipe.",
    website: "https://github.com/Abhishekkuntare/Reactnative_food_app",
    prev: "/",
  },
];

export default projects;
